import TeamMembersTable from '../components/teamMembers/TeamMembersTable';
import Filters from '../components/filters/Filters';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import { useTeamMembersTableStore } from '../store/myTeamTableStateStore';
import UsageTracker from '../../../utils/UsageTracker';
import { PAGE_NAMES } from '../../../constants/Navigation';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MyTeamMembers = () => {
  const store = useTeamMembersTableStore();
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: PAGE_NAMES.MY_TEAM_MEMBERS
    });
  }, []);
  return /*#__PURE__*/_jsxs(ListingPage, {
    headerComponent: null,
    children: [/*#__PURE__*/_jsx(Filters, {
      store: store
    }), /*#__PURE__*/_jsx(TeamMembersTable, {})]
  });
};
export default MyTeamMembers;